import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    selectedProductList: [],
    showDiv: false,
    selectedBlockIndex: -1, //记录正在改变参数的产品序号
    largeImgURL: "", //存放合成后的图片的base64
    canvasFunction: null,
    productOriginLeft: 0, // 产品生成位置
    productOriginTop: 0, // 产品生成位置
  },
  mutations: {
    // 列表添加产品
    addSelectedProductList(state, product) {
      state.selectedProductList.push(product);
    },

    // 列表更新产品信息
    changeSelectedProductList(state, product) {
      let temp = state.selectedProductList;
      state.selectedProductList = []; // 为了触发事件监听
      temp[state.selectedBlockIndex] = product;
      state.selectedProductList = temp;
    },

    // 列表整体赋值
    setSelectedProductList(state, productList) {
      state.selectedProductList = [];
      state.selectedProductList = productList;
    },
    setShowDiv(state, value) {
      state.showDiv = value;
    },
    setSelectedBlockIndex(state, index) {
      state.selectedBlockIndex = index;
    },
    setlargeImgURL(state, imgURL) {
      state.largeImgURL = imgURL;
    },
    setCanvasFunction(state, func) {
      state.canvasFunction = func;
    },
    setProductOriginLeft(state, left) {
      state.productOriginLeft = left;
    },
    setProductOriginTop(state, top) {
      state.productOriginTop = top;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js